import { Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { AppDispatch, RootState } from "../../../state/configureStore";
import { DeleteModal } from "../../../components/molecules/DeleteModal";
import {
  AlertData,
  deleteAlert,
} from "../../../state/thunks/machineAlertsThunks";
import { resetSavingStatus } from "../../../state/reducers/slices/machineAlertSlice";

interface DeleteAlertModalProps {
  alert: AlertData | null;
  onClose: () => void;
}

export const DeleteAlertModal = ({ alert, onClose }: DeleteAlertModalProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const { saving } = useSelector((state: RootState) => state.machineAlert);

  //modal is automatically closed when status is 'saved
  useEffect(() => {
    if (saving === "saved" && alert) {
      // When status is set to "saved", the modal is closed
      onClose();
    }
  }, [saving, onClose, alert]);

  const handleConfirmDelete = async () => {
    if (alert) {
      await dispatch(deleteAlert(alert));
    }
  };

  const handleClose = () => {
    dispatch(resetSavingStatus()); // <--- cleares "failed" in Redux (machineAlertSlice)
    onClose();
  };

  return (
    <DeleteModal
      title="Remove Alert"
      open={Boolean(alert)}
      closeModal={handleClose}
      onSave={handleConfirmDelete}
      saving={saving}
      savingFailedMessage="Could not remove the alert. Please try again."
    >
      <Typography>
        Are you sure you want to remove the alert for
        <strong> {alert?.eventType} </strong>
        to
        <strong> {alert?.emailRecipient}</strong>?
      </Typography>
    </DeleteModal>
  );
};
